import React, { createContext, useContext, useState, useCallback, useEffect } from 'react';
import api from '../utils/api';

const NotificationContext = createContext();

export const useNotifications = () => {
  const context = useContext(NotificationContext);
  if (!context) {
    throw new Error('useNotifications must be used within a NotificationProvider');
  }
  return context;
};

export const NotificationProvider = ({ children }) => {
  const [count, setCount] = useState(0);

  const fetchCount = useCallback(async () => {
    try {
      const response = await api.get('/notificaciones/count');
      setCount(response.data.count || 0);
    } catch (error) {
      console.error('Error fetching notification count:', error);
    }
  }, []);

  const resetCount = useCallback(() => {
    setCount(0);
  }, []);

  const decrementCount = useCallback((amount = 1) => {
    setCount(prev => Math.max(0, prev - amount));
  }, []);

  const refreshCount = useCallback(() => {
    fetchCount();
  }, [fetchCount]);

  return (
    <NotificationContext.Provider value={{ 
      count, 
      setCount, 
      fetchCount, 
      resetCount, 
      decrementCount,
      refreshCount 
    }}>
      {children}
    </NotificationContext.Provider>
  );
};

export default NotificationContext;
